export default doc => {
  // Homepage route fallback
  return "/";
};
